@if(visible) {
<app-stepper [config]="stepperConfig" [visible]="visible" (visibleChange)="visible = $event; visibleChange.emit($event)"
    (close)="mode === 'edit' ? closeEditForm.emit() : visibleChange.emit(false)" (finish)="onFinish()"
    (nextStepClick)="onNextStep()" (stepChange)="currentStepIndex = $event.currentIndex" [finishButtonLoading]="Saving">

    <!-- Step 1: Upload Form (skipped in edit mode via currentStepIndex: 1) -->
    <div *stepperStep="uploadFormStepConfig" class="flex flex-col h-full">
        <div class="flex-grow w-full relative">
            @if(Saving) {
            <div class="absolute flex justify-center items-center z-10 w-full h-full bg-white/80 top-0 left-0">
                <p-progressSpinner class="my-4" strokeWidth="4"
                    [style]="{width: '2.5rem', height: '2.5rem'}"></p-progressSpinner>
            </div>
            }
            <div [ngClass]="{'pointer-events-none blurred-background': Saving}" class="my-4">
                <app-file-drop [fileTypes]="allowedFileTypes" [multiple]="false" (uploadData)="onFormUpload($event)"
                    (removeFile)="onFormFileRemove($event)" [maxFileSize]="90 * 1000 * 1000"
                    [existingFiles]="formFiles" />
            </div>
        </div>
    </div>

    <!-- Step 2: Knowledge Base -->
    <div *stepperStep="knowledgeBaseStepConfig" class="flex flex-col h-full">
        @if(Saving) {
        <div class="absolute flex justify-center items-center z-10 w-full h-full bg-white/80 top-0 left-0">
            <p-progressSpinner class="my-4" strokeWidth="4"
                [style]="{width: '2.5rem', height: '2.5rem'}"></p-progressSpinner>
        </div>
        } @else {
        <div class="flex flex-col gap-1 flex-1 min-h-0">
            <!-- Q/A Bank Toggle -->
            <div class="flex justify-between items-center mb-1">
                <div class="flex gap-2">
                    <span>{{'Would you like to retrieve answers from the Q&A Bank?' | textCase}}</span>
                    <app-toggle [(ngModel)]="useQnaPair" class="orange-switch"></app-toggle>
                </div>
                <app-button label="{{'Upload Files' | textCase}}" icon="pi pi-upload" (clicked)="uploadFile()"
                    variant="outlined" severity="contrast" />
            </div>

            <!-- Tab View -->
            <div class="flex gap-3 flex-1 min-h-0 mb-2">
                <div class="flex w-full border border-gray-200 min-h-0 rounded-2xl p-2">
                    <p-tabs [(value)]="activeTabIndex" class="w-full">
                        <p-tablist>
                            <p-tab value="0" class="flex items-center !gap-2">
                                <span class="font-bold whitespace-nowrap">{{'Knowledge Base' | textCase}}</span>
                            </p-tab>
                            <p-tab value="1" class="flex items-center !gap-2">
                                <span class="font-bold whitespace-nowrap">{{'Files' | textCase}}</span>
                            </p-tab>
                        </p-tablist>
                        <p-tabpanels class="flex-1 min-h-0 overflow-hidden">
                            <p-tabpanel value="0" class="h-full">
                                <div class="flex flex-col gap-3 h-full w-full max-h-full">
                                    <!-- Search Input -->
                                    <app-search-bar placeholder="{{'Search knowledge base' | textCase}}"
                                        [(ngModel)]="knowledgeBaseStore.searchValue" (search)="onKnowledgeBaseSearch()">
                                    </app-search-bar>

                                    <!-- Select All Checkbox -->
                                    <div class="flex items-center gap-2 mx-2">
                                        <app-checkbox
                                            [config]="{ binary: true, size: 'small', label: 'Select All', disabled: knowledgeBaseStore.currentPageStores.length === 0 }"
                                            [(value)]="knowledgeBaseStore.selectAll"
                                            (onChange)="onSelectAllKnowledgeBases($event)">
                                        </app-checkbox>
                                        <p *ngIf="knowledgeBaseStore.selectedStores.length > 0">({{

                                            knowledgeBaseStore.selectedStores.length }})</p>
                                    </div>

                                    <!-- Knowledge Base List -->
                                    <div class="flex-1 rounded-base overflow-y-auto">
                                        @if(knowledgeBaseStore.loading) {
                                        <div class="flex justify-center items-center h-32">
                                            <p-progressSpinner strokeWidth="4"
                                                [style]="{width: '1.875rem', height: '1.875rem'}">
                                            </p-progressSpinner>
                                        </div>
                                        } @else if(knowledgeBaseStore.currentPageStores.length === 0) {
                                        <div class="flex justify-center items-center h-32 text-gray-500">
                                            <span>{{'No knowledge bases found' | textCase}}</span>
                                        </div>
                                        } @else {
                                        <div class="flex flex-col gap-2 overflow-y-auto max-h-full">
                                            @for(kb of knowledgeBaseStore.currentPageStores; track kb._id) {
                                            <div class="flex items-center gap-3 border rounded-base px-2 py-2 hover:bg-arena-orange-100 cursor-pointer"
                                                [ngClass]="{'bg-arena-orange-100': kb.selected}">
                                                <app-checkbox [config]="{ binary: true, size: 'small' }"
                                                    [value]="kb.selected"
                                                    (onChange)="onKnowledgeBaseCheckboxChange(kb, !!$event.checked)"
                                                    class="items-center">
                                                </app-checkbox>
                                                <div class="flex justify-between items-center gap-2 w-full">
                                                    <div class="flex items-center gap-2">
                                                        <i [innerHTML]="SVGS.FOLDER | sanitizeHtml" alt=""
                                                            class="scale-75"></i>
                                                        <div class="flex flex-col">
                                                            <span
                                                                class="font-semibold text-sm truncate max-w-[12.5rem]">{{kb.name}}</span>
                                                            <span
                                                                class="font-medium text-sm truncate-description max-w-full">{{kb.description}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-center gap-2 flex-shrink-0">
                                                        <span class="text-xs text-gray-600">
                                                            {{kb.files.length || 0}} {{'files' |
                                                            textCase:CASE_TYPE.LOWER}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>

                                    <!-- Pagination -->
                                    <div class="kb-paginator">
                                        <p-paginator [rows]="knowledgeBaseStore.limit || 10" appendTo="body"
                                            [totalRecords]="knowledgeBaseStore.totalRecords || 0"
                                            [first]="knowledgeBaseStore.skip" [rowsPerPageOptions]="rowsPerPageOptions"
                                            (onPageChange)="onKnowledgeBasePageChange($event)">
                                        </p-paginator>
                                    </div>
                                </div>
                            </p-tabpanel>

                            <p-tabpanel value="1" class="h-full">
                                <div
                                    class="h-full flex flex-col gap-3 2xl:max-h-[calc(100vh-32rem)] lg:max-h-[calc(100vh-30rem)]">
                                    <!-- Search Input -->
                                    <app-search-bar placeholder="Search files..."
                                        [(ngModel)]="knowledgeBaseFiles.searchValue"
                                        (search)="onKnowledgeBaseFilesSearch()">
                                    </app-search-bar>

                                    <!-- Select All Checkbox -->
                                    <div class="flex items-center gap-2 mx-2.5">
                                        <app-checkbox
                                            [config]="{ binary: true, size: 'small', label: 'Select All', disabled: knowledgeBaseFiles.currentPageFiles.length === 0 }"
                                            [(value)]="knowledgeBaseFiles.selectAll"
                                            (onChange)="onSelectAllKnowledgeBasesFiles($event)">
                                        </app-checkbox>
                                        <p *ngIf="knowledgeBaseFiles.selectedFiles.length > 0">({{

                                            knowledgeBaseFiles.selectedFiles.length }})</p>
                                    </div>

                                    <!-- Files List -->
                                    <div class="flex-1 rounded-base max-h-full overflow-y-auto">
                                        @if(knowledgeBaseFiles.loading) {
                                        <div class="flex justify-center items-center h-32">
                                            <p-progressSpinner strokeWidth="4"
                                                [style]="{width: '1.875rem', height: '1.875rem'}">
                                            </p-progressSpinner>
                                        </div>
                                        } @else if(knowledgeBaseFiles.currentPageFiles.length === 0) {
                                        <div class="flex justify-center items-center h-32 text-gray-500">
                                            <span>{{'No files found' | textCase}}</span>
                                        </div>
                                        } @else {
                                        <div class="flex flex-col gap-2 overflow-y-auto">
                                            @for(kb of knowledgeBaseFiles.currentPageFiles; track kb._id) {
                                            <div class="flex items-center gap-3 border rounded-base px-2 py-2 hover:bg-arena-orange-100 cursor-pointer"
                                                [ngClass]="{'bg-arena-orange-100': kb.selected}">
                                                <app-checkbox [config]="{ binary: true, size: 'small' }"
                                                    [value]="kb.selected"
                                                    (onChange)="onKnowledgeBaseFilesCheckboxChange(kb, !!$event.checked)"
                                                    class="items-center">
                                                </app-checkbox>
                                                <div class="flex justify-between items-center gap-2 w-full">
                                                    <div class="flex items-center gap-2">
                                                        @if(kb.mimeType == "pdf"){
                                                        <i [innerHTML]="SVGS.PDF | sanitizeHtml"></i>
                                                        }@else if(kb.mimeType == "docx"){
                                                        <i [innerHTML]="SVGS.DOCX | sanitizeHtml"></i>
                                                        }@else if(kb.mimeType == "xlsx" || kb.mimeType == "xls"){
                                                        <i class="pi pi-file-excel text-xl text-green-600"></i>
                                                        }
                                                        <span class="font-medium text-sm">{{kb.name}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>

                                    <!-- Pagination -->
                                    <div class="flex-shrink-0 kb-paginator">
                                        <p-paginator [rows]="knowledgeBaseFiles.limit || 10" appendTo="body"
                                            [totalRecords]="knowledgeBaseFiles.totalRecords || 0"
                                            [rowsPerPageOptions]="rowsPerPageOptions" [first]="knowledgeBaseFiles.skip"
                                            (onPageChange)="onKnowledgeBaseFilesPageChange($event)">
                                        </p-paginator>
                                    </div>
                                </div>
                            </p-tabpanel>
                        </p-tabpanels>
                    </p-tabs>
                </div>
                <div class="flex w-full border border-gray-200 min-h-0 rounded-2xl p-4">
                    <div class="flex flex-col gap-2 w-full min-h-0">
                        <span class="text-sm font-semibold">{{'Selected Knowledge Bases and Files' | textCase}}
                            ({{combinedSelectedItems.length}} {{'items' | textCase}})</span>
                        <div class="flex flex-col gap-2 overflow-y-auto flex-1 min-h-0">
                            @for(item of combinedSelectedItems; track item.type + '_' + item.item._id) {
                            <div
                                class="flex items-center justify-between gap-2 border rounded-base px-2 py-2 hover:bg-gray-50">
                                <div class="flex items-center gap-2">
                                    @if(item.type === 'knowledgeBase') {
                                    <i [innerHTML]="SVGS.FOLDER | sanitizeHtml" alt="" class="scale-75"></i>
                                    <div class="flex flex-col">
                                        <span
                                            class="font-medium text-sm truncate max-w-[12.5rem]">{{item.item.name}}</span>
                                        <span
                                            class="font-medium text-sm truncate-description max-w-full">{{getItemDescription(item)}}</span>
                                    </div>
                                    } @else {
                                    @if(getItemMimeType(item) == "pdf"){
                                    <i [innerHTML]="SVGS.PDF | sanitizeHtml"></i>
                                    }@else if(getItemMimeType(item) == "docx"){
                                    <i [innerHTML]="SVGS.DOCX | sanitizeHtml"></i>
                                    }@else if(getItemMimeType(item) == "xlsx" || getItemMimeType(item) == "xls"){
                                    <i class="pi pi-file-excel text-xl text-green-600"></i>
                                    }
                                    <span class="font-medium text-sm">{{item.item.name}}
                                        ({{getItemType(item)}})</span>
                                    }
                                </div>
                                <app-button icon="pi pi-trash" variant="outlined" severity="danger"
                                    (clicked)="onRemoveFromCombinedList(item)" />
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>

    <!-- Step 3: Custom Instructions -->
    <div *stepperStep="customInstructionsStepConfig" class="flex flex-col h-full">
        @if(Saving) {
        <div class="absolute flex justify-center items-center z-10 w-full h-full bg-white/80 top-0 left-0">
            <p-progressSpinner class="my-4" strokeWidth="4"
                [style]="{width: '2.5rem', height: '2.5rem'}"></p-progressSpinner>
        </div>
        }
        <div class="flex flex-col gap-4 h-full">
            <div class="flex flex-col w-[40%]">
                <label class="block font-semibold mb-2 text-gray-500">{{'Due Date' | textCase}}</label>
                <app-datepicker [(value)]="dueDate" [config]="projectDueDateConfig" />
            </div>

            <app-expandable-textarea label="{{'Add custom prompt instructions' | textCase}}"
                placeholder="Enter custom instructions..." [maxLength]="2000" [rows]="6" [showIcon]="true"
                iconSrc="icons/star.svg" iconTooltip="AI Generated"
                placeholderTitle="Add any special instructions you'd like the AI to follow when generating long-form answers. For example:"
                [placeholderItems]="[
                    'Highlight any specific market differentiators',
                    'Use American English with a cheery tone',
                    'Keep technical details concise unless asked otherwise',
                    'Highlight our carbon-neutral supply chain where relevant'
                ]" [(ngModel)]="customInstructions">
            </app-expandable-textarea>
            <div>
                <label class="font-semibold text-gray-500 mb-2">{{'Tone' | textCase}}</label>
                <div class="flex gap-4">
                    <div class="flex items-center">
                        <p-radioButton name="tone" [value]="CustomisationTone.NEUTRAL" [(ngModel)]="selectedTone"
                            inputId="neutral" class="orange-radio">
                        </p-radioButton>
                        <label for="neutral" class="ml-2 text-sm">{{CustomisationTone.NEUTRAL | textCase}}</label>
                        <i class="pi pi-info-circle text-gray-400 ml-1 hover:text-gray-600" style="font-size: 0.8rem"
                            pTooltip="{{'A clear, formal tone suited for professional and official documentation.' | textCase}}"
                            tooltipPosition="bottom"></i>
                    </div>
                    <div class="flex items-center">
                        <p-radioButton name="tone" [value]="CustomisationTone.FORMAL" [(ngModel)]="selectedTone"
                            inputId="formal" class="orange-radio">
                        </p-radioButton>
                        <label for="formal" class="ml-2 text-sm">{{CustomisationTone.FORMAL | textCase}}</label>
                        <i class="pi pi-info-circle text-gray-400 ml-1 hover:text-gray-600" style="font-size: 0.8rem"
                            pTooltip="{{'A precise and detail-oriented tone used to convey complex or domain-specific information.' | textCase}}"
                            tooltipPosition="bottom"></i>
                    </div>
                    <div class="flex items-center">
                        <p-radioButton name="tone" [value]="CustomisationTone.TECHNICAL" [(ngModel)]="selectedTone"
                            inputId="technical" class="orange-radio">
                        </p-radioButton>
                        <label for="technical" class="ml-2 text-sm">{{CustomisationTone.TECHNICAL | textCase}}</label>
                        <i class="pi pi-info-circle text-gray-400 ml-1 hover:text-gray-600" style="font-size: 0.8rem"
                            pTooltip="{{'A clear and balanced tone that maintains professionalism without being overly formal or technical.' | textCase}}"
                            tooltipPosition="bottom"></i>
                    </div>
                </div>
            </div>

            <div>
                <label class="font-semibold text-gray-500 mb-2">{{'Verbosity' | textCase}}</label>
                <div class="ml-4 relative w-[30%] mt-2">
                    <p-slider [(ngModel)]="verbosityLevel" [min]="0" [max]="2" [step]="1" class="w-full mb-4">
                    </p-slider>

                    <div class="absolute top-0 left-0 w-full h-6 flex bg-none">
                        <div class="w-1/3 h-full cursor-pointer" (click)="setVerbosity(0)"></div>
                        <div class="w-1/3 h-full cursor-pointer" (click)="setVerbosity(1)"></div>
                        <div class="w-1/3 h-full cursor-pointer" (click)="setVerbosity(2)"></div>
                    </div>

                    <div class="flex justify-between text-xs text-gray-600">
                        <div class="text-center cursor-pointer" (click)="setVerbosity(0)">
                            <div class="font-medium">{{'Concise' | textCase}}</div>
                            <div>&lt;150 {{'words' | textCase:CASE_TYPE.LOWER}}</div>
                        </div>
                        <div class="text-center cursor-pointer" (click)="setVerbosity(1)">
                            <div class="font-medium">{{'Moderate' | textCase}}</div>
                            <div>150-300 {{'words' | textCase:CASE_TYPE.LOWER}}</div>
                        </div>
                        <div class="text-center cursor-pointer" (click)="setVerbosity(2)">
                            <div class="font-medium">{{'Detailed' | textCase}}</div>
                            <div>&gt;300 {{'words' | textCase:CASE_TYPE.LOWER}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Step 4: Milestones -->
    <div *stepperStep="milestonesStepConfig" class="flex flex-col h-full">
        @if(Saving) {
        <div class="absolute flex justify-center items-center z-10 w-full h-full bg-white/80 top-0 left-0">
            <p-progressSpinner class="my-4" strokeWidth="4"
                [style]="{width: '2.5rem', height: '2.5rem'}"></p-progressSpinner>
        </div>
        }
        <div class="h-full w-full">
            <div class="h-full w-full flex flex-column justify-center overflow-y-auto">
                <app-milestones #milestonesComponent [milestones]="milestones" [showHeader]="false"
                    [maxMilestoneDueDate]="dueDate" (milestonesChange)="onMilestonesChange($event)"
                    class="h-full w-full" [showActions]="false" [(editableMilestones)]="editableMilestones"
                    [(deletedMilestoneIds)]="deletedMilestoneIds">
                </app-milestones>
            </div>
        </div>
    </div>

    <!-- Step 5: Team -->
    <div *stepperStep="teamStepConfig" class="h-full 2xl:max-h-[calc(100vh-19rem)] lg:max-h-[calc(100vh-18rem)] w-full">
        @if(Saving) {
        <div class="absolute flex justify-center items-center z-10 w-full h-full bg-white/80 top-0 left-0">
            <p-progressSpinner class="my-4" strokeWidth="4"
                [style]="{width: '2.5rem', height: '2.5rem'}"></p-progressSpinner>
        </div>
        }
        <div class="h-full w-full flex flex-column justify-center overflow-y-auto">
            <app-share-to-users class="h-full w-full" [shareDetails]="shareDetails" [projectId]="project"
                (addUserToShare)="addUserToShare($event)" (removeUserFromShare)="removeUserFromShare($event)"
                (updateSharedUser)="updateSharedUser($event)"
                (changeSharedWithWorkspace)="changeSharedWithWorkspace($event)"
                (changeSharedWithProject)="changeSharedWithProject($event)"
                (changeAnyoneAccess)="changeAnyoneAccess($event)" [contract]="contract"
                [isDocumentForm]="true"></app-share-to-users>
        </div>
    </div>

</app-stepper>

<app-dialog [(visible)]="showUploadDialog" [showCloseButton]="false" class="max-w-[36rem] !p-0 !gap-0">
    <ng-template #bodyTemplate>
        <app-upload-docs [dialogData]="uploadDialogData" (dialogClosed)="onUploadDialogClosed($event)" />
    </ng-template>
</app-dialog>
}